import React from 'react';
import { IIconProps } from './IIconProps';

export const PinIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={iconClass}
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 6.6665C14 11.3332 8 15.3332 8 15.3332C8 15.3332 2 11.3332 2 6.6665C2 3.3528 4.68629 0.666504 8 0.666504C11.3137 0.666504 14 3.3528 14 6.6665V6.6665Z"
				stroke="#6A6E9B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 8.6665C9.10457 8.6665 10 7.77107 10 6.6665C10 5.56193 9.10457 4.6665 8 4.6665C6.89543 4.6665 6 5.56193 6 6.6665C6 7.77107 6.89543 8.6665 8 8.6665Z"
				stroke="#6A6E9B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
